export default "__VITE_ASSET__32fc1159__"